import React from "react";
import { useState } from "react";
import "./sidenav.css";
import "./nav.css";
import $ from 'jquery';

const SideNav = ({ items, activeItem, onSelect, className,types, contentTrigger, funds, fundsUpdateTrigger }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [typeStatus, setTypeStatus] = useState(types)


  
if (types) { 

  return (
    <>
      <div
        className={`flex trigger flex-col w-48 border-r d-none d-md-block sidenav ${className}`}
      >
        {items.map((item) => (
          <button
            style={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontStyle: "Medium",
              fontSize: "14px",
              lineHeight: "160%",
              letterSpacing: "0%",
            }}
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
            key={item}
            onClick={() =>{
              onSelect(item) 
              contentTrigger(item) } }
            className={` nav flex-column nav-pills  nav-btn 
          ${activeItem === item ? "activeItem" : ""}`}
          >
            {item}
          </button>
        ))}
      </div>
    </>
  );
}

if (funds) { 
    fundsUpdateTrigger()

  return (
    <>
      <div
        className={`flex trigger flex-col w-48 border-r d-none d-md-block sidenav ${className}`}
      >
        {items.map((item) => (
          <button
            style={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontStyle: "Medium",
              fontSize: "14px",
              lineHeight: "160%",
              letterSpacing: "0%",
            }}
            id={item}
            role="tablist"
            aria-orientation="vertical"
            key={item}
            onClick={() =>{
              onSelect(item) 
              fundsUpdateTrigger() } }
            className={` nav flex-column nav-pills  nav-btn fund-btn
          ${activeItem === item ? "activeItem" : ""}`}
          >
            {item}
          </button>
        ))}
      </div>
    </>
  );
}

if (!types && !funds) { 

  return (
    <>
      <div
        className={`flex trigger flex-col w-48 border-r d-none d-md-block sidenav ${className}`}
      >
        {items.map((item) => (
          <button
            style={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontStyle: "Medium",
              fontSize: "14px",
              lineHeight: "160%",
              letterSpacing: "0%",
            }}
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
            key={item}
            onClick={() =>{
              onSelect(item) 
               } }
            className={` nav flex-column nav-pills  nav-btn 
          ${activeItem === item ? "activeItem" : ""}`}
          >
            {item}
          </button>
        ))}
      </div>
    </>
  );
}

};

export default SideNav;

<div class="d-flex align-items-start">
  <div
    class="nav flex-column nav-pills me-3"
    id="v-pills-tab"
    role="tablist"
    aria-orientation="vertical"
  >
    <button
      class="nav-link active"
      id="v-pills-home-tab"
      data-bs-toggle="pill"
      data-bs-target="#v-pills-home"
      type="button"
      role="tab"
      aria-controls="v-pills-home"
      aria-selected="true"
    >
      Home
    </button>
  </div>
  <div class="tab-content" id="v-pills-tabContent">
    <div
      class="tab-pane fade show active"
      id="v-pills-home"
      role="tabpanel"
      aria-labelledby="v-pills-home-tab"
      tabindex="0"
    >
      ...
    </div>
  </div>
</div>;
